import React, { Component } from 'react';
const $ = require('jquery');
class DischargeTracker extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            break_status: null,
            break_time: null,
        }
    }
    
    componentDidMount(){
    }

    
    
    render() {
        return (
            <div className="card p-3 m-3">
                    <iframe src="https://crm.kimshospitals.com:3001/d/f8d699b5-d367-439a-9c44-1dd91f39d530/discharge-tracker?orgId=1&var-unit=All&var-totaltat=2h&var-summarytat=2h&var-overallcashtat=2h&var-overallinstat=2h&var-insurancetat=3h&var-lantat=30m&var-sctat=30m&var-pctat=30m&var-hctat=30m&theme=light" width="100%" height="600" frameborder="0"></iframe>
            </div>

        )

    }
}
export default DischargeTracker;